$(document).ready(() => {
    $(".free-dropdown__show").click(function () {
        $(".free-dropdown").toggleClass("_active");
    })
    $(".free-dropdown__item").click(function () {
        $(this).toggleClass("_active");
    })

    $('.free-players').on('click', '.free-card button', event => {
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'delete',
            url: FREE_PLAYER_URL,
            contentType: "application/json; charset=utf-8",
            processData: false,
            success: response => {
                $(event.target).closest('.free-card').remove();
            },
            error: TRNMNT_helpers.onErrorAjax,
            context: TRNMNT_helpers
        });
    });

    $('.free-dropdown__badge').on('click', event => {
        event.preventDefault();

        const positions = [];
        $('.free-dropdown__item').each(function (i) {
            const $item = $(this);

            if ($item.hasClass('_active')) {
                positions.push($item.data('position'));
            }
        });
        if (!positions.length) {
            TRNMNT_helpers.showNotification(
                'Не выбрана ни одна позиция', {alertType: 'error'}
            );
            return;
        }

        $(".free-dropdown").toggleClass("_active");
        TRNMNT_helpers.disableButtons();
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'post',
            url: FREE_PLAYER_URL,
            data: JSON.stringify({
                positions: positions,
            }),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            processData: false,
            success: response => {
                console.log(response);
                TRNMNT_helpers.enableButtons();
                $('.free-dropdown__item').each(function (i) {
                    $(this).removeClass('_active');
                });

                $('.free-card').each(function (i) {
                    const $block = $(this);
                    if ($block.data('id') === response.data.player.id) {
                        $block.remove();
                    }
                });

                $('.free-players').prepend(TRNMNT_helpers.createPlayerBlock(response.data.player));
            },
            error: TRNMNT_helpers.onErrorAjax,
            context: TRNMNT_helpers
        });
    });

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'get',
        url: FREE_PLAYER_URL,
        contentType: "application/json; charset=utf-8",
        processData: false,
        success: response => {
            const $players = $('.free-players');

            for (let player of response.data.players) {
                const $playerBlock = TRNMNT_helpers.createPlayerBlock(player);

                $players.append($playerBlock);
            }
        },
        error: TRNMNT_helpers.onErrorAjax,
        context: TRNMNT_helpers
    });
});

$(document).mouseup(function (e) {
    var div = $('.free-dropdown');
    if (!div.is(e.target) && div.has(e.target).length === 0) {
        if ($(".free-dropdown").hasClass("_active")) {
            $(".free-dropdown").removeClass("_active")
        }
    }
});
